import Repository from "../Repository";

const resource = "/columns";
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getColumn(id){
        return Repository.get(`${resource}/${id}`);
    },
    createColumn(json){
        return Repository.post(`${resource}`,json);
    },
    updateColumn(id,json){
        return Repository.put(`${resource}/${id}`,json);
    },
    deleteColumn(id){
        return Repository.delete(`${resource}/${id}`);
    }
}